import React from 'react';

import PropTypes from 'prop-types';

import { PLAY_STORE_LINK, PLAY_STORE } from './constants';

import styles from './storeButton.module.scss';

const PlayStoreButton = ({ language, ...props }) => (
  <a
    alt="Hotmart - Google Play Store"
    href={PLAY_STORE_LINK}
    rel="noopener noreferrer"
    target="_blank"
    className={styles.button}
    {...props}
  >
    <img src={PLAY_STORE[language] || PLAY_STORE.EN} alt="Play Store" />
  </a>
);

PlayStoreButton.propTypes = {
  language: PropTypes.string.isRequired
};

export default PlayStoreButton;
